import { FC, PropsWithChildren } from 'react';
import { CatList } from '@blocks-react/components/List';

interface ListWithIconsProps {
  className?: string;
}

export const ListWithIcons: FC<PropsWithChildren<ListWithIconsProps>> = ({
  children,
  className,
}) => {
  return (
    <CatList className={className} spacing="padded">
      {children}
    </CatList>
  );
};
